import { formatFileSize } from '../../lib/dateUtils';
import type { FileStats } from '../../hooks/useFiles';

interface Props {
  totalCount: number;
  stats: FileStats;
}

export function FileStatsCards({ totalCount, stats }: Props) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-steel">Total Files</p>
            <p className="text-2xl font-bold text-navy mt-1">{totalCount}</p>
          </div>
          <div className="text-3xl">📎</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-steel">Audio Files</p>
            <p className="text-2xl font-bold text-navy mt-1">{stats.audioCount}</p>
          </div>
          <div className="text-3xl">🎵</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-steel">Transcripts</p>
            <p className="text-2xl font-bold text-navy mt-1">{stats.transcriptCount}</p>
          </div>
          <div className="text-3xl">📄</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-steel">Total Storage</p>
            <p className="text-2xl font-bold text-navy mt-1">{formatFileSize(stats.totalBytes)}</p>
          </div>
          <div className="text-3xl">💾</div>
        </div>
      </div>
    </div>
  );
}
